<template>
  <div>
    <div class="positionBox">
      <!-- <p class="positionTitle">职位列表</p> -->
      <div class="createdPosition">
        <div class="searchbox" v-if="isposition&&isOther">
          <el-cascader
          placeholder="所在城市"
          v-model="map_code"
          :options="holCitys"
          :props="{
            expandTrigger: 'hover',
            value: 'code',
            label: 'name',
            children: 'cities'
          }"
          @change="cityChange"
        ></el-cascader>
          <el-input
            style="width: 220px;margin-left:6px"
            size="mini"
            v-model="searchpositionname"
            placeholder="请输入职位名称"
            @keyup.enter.native="query"
          ></el-input>
          <span @click="query" class="searchbtn">查询</span>
          <span @click="handleResetPositionName" class="resetbtn">重置</span>
        </div>
        <div class="searchbox" v-if="!isposition">
          <el-input
            style="width: 220px;margin-left:6px"
            size="mini"
            v-model="searchcompanyname"
            @keyup.enter.native="handleSearchCompanyName"
            placeholder="请输入公司名称"
          ></el-input>
          <span @click="handleSearchCompanyName" class="searchbtn">查询</span>
          <span @click="handleResetCompany" class="resetbtn">重置</span>
        </div>
        <el-button
          v-if="isposition"
          :disabled="!handleChildinfo.length"
          class="createdBtn"
          @click="handleOpenCreate"
          type="primary"
          >+ 创建职位</el-button
        >
        <el-button
          v-else
          @click="handleOpenCreateCompany"
          class="createdBtn"
          type="primary"
          >+ 新建公司</el-button
        >
      </div>
      <!-- 主体数据 -->
      <div class="tableBox">
        <el-tabs v-model="activeName" @tab-click="handleChangeTabs">
          <el-tab-pane v-for="(item,i) in handleChildList" :years="item.years" :key="i" :label="item.identify===8||item.identify==='all'?item.childHandleName:item.childHandleName+'职位'" :name="item.value">
            <!-- <span class="is_double" v-if="item.value==='8'&&is_double===0">当前暂无参与双选会活动，如需参与请联系韩先生：18918459526</span> -->
            <TablePage
              :data="positionList"
              :positionStatus="positionStatus"
              :page="pages"
              @pageChange="handleChangeCurrentPage"
              @handleEditPosition="handleEditPosition"
              @handleStopPosition="handleStopOrPosition"
              @refresh8="refresh8"
            ></TablePage>
          </el-tab-pane>
          <el-tab-pane v-if="isHR === false" label="公司列表" name="third">
            <TablePageCompany
              :data="companyList"
              :page="CompanyPage"
              @pageChange="handleChangeCurrentPageCompany"
              @handleEditCompany="handleEditCompany"
            ></TablePageCompany>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 职位类型 -->
      <el-dialog
        custom-class="new-dialog"
        :visible.sync="positionTypeVisible"
        :show-close="false"
      >
        <div v-for="(item,i) in handleChildinfo" :key="i" @click="handlePublish(item)">
          <img :src="require('../../assets/imgs/type'+item.identify+'.png')" />
          <span>{{item.identify===8?item.childHandleName:item.childHandleName+'岗'}}</span>
        </div>
      </el-dialog>
      <!-- 职位弹窗 -->
      <el-dialog
        :title="dialogposition"
        :visible.sync="isShowCreatedPosition"
        width="60%"
        center
        :close-on-click-modal="false"
        class="createPosition"
      >
        <div class="createBox">
          <div class="companyMsg">
            <p class="title">公司信息</p>
            <div class="companyText">
              <!-- 猎头展示 -->
              <div v-if="isHR === false">
                <div style="margin-right: 49px">
                  <span>公司名称</span>
                  <el-select
                    :disabled="isdisabled"
                    v-model="selectedCompany"
                    placeholder="请选择"
                    @change="handlechangecompany"
                  >
                    <el-option
                      v-for="item in createCompanyList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <img
                    v-show="isShowAdd"
                    @click="handleOpenAddCompany"
                    style="width: 30px; height: 30px"
                    src="@/assets/imgs/addcompany.png"
                    alt
                  />
                  <span style="color: red; margin-left: 5px">*</span>
                </div>
                <div style="margin-right: 60px">
                  <span>对外显示名称</span>
                  <el-input
                    disabled
                    v-model="foreignName"
                    placeholder="请输入内容"
                  ></el-input>
                  <span style="color: red; margin-left: 5px">*</span>
                </div>
                <div class="uploadimg">
                  <span>公司logo</span>
                  <uploadimg
                    :showimg="isshowimg"
                    style="display: inline-block; margin-left: 18px"
                    :img="companyLogo"
                    :dialogposition="dialogposition"
                    :size="{ width: 113, height: 40 }"
                  ></uploadimg>
                  <span style="color: red; margin-left: 5px">*</span>
                </div>
              </div>
            </div>
            <div class="companyTexts">
              <!-- HR展示 -->
              <div v-if="isHR === true">
                <div style="margin-right: 48px">
                  <span>公司名称</span>
                  <el-input
                    v-model="selectedCompany"
                    disabled
                    placeholder="请输入内容"
                  ></el-input>
                  <span style="color: red; margin-left: 5px">*</span>
                </div>
                <div class="uploadimg">
                  <span>公司logo</span>
                  <uploadimg
                    style="display: inline-block; margin-left: 18px"
                    :img="companyLogo"
                    :size="{ width: 113, height: 40 }"
                  ></uploadimg>
                  <span style="color: red; margin-left: 5px">*</span>
                </div>
              </div>
            </div>
            <!-- 公共的公司信息 -->
            <div class="companyTexts">
              <div>
                <div style="margin-right: 60px">
                  <span>融资阶段</span>
                  <el-input
                    disabled
                    v-model="financingStage"
                    placeholder="请输入内容"
                  ></el-input>
                </div>
                <div style="margin-right: 60px">
                  <span>公司规模</span>
                  <el-select
                    v-model="companyScale"
                    placeholder="请选择"
                    disabled
                    @change="handleselectcompanyScale"
                  >
                    <el-option
                      v-for="item in companyScaleList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <span style="color: red; margin-left: 5px">*</span>
                </div>
                <div>
                  <span>公司福利</span>
                  <el-select
                    multiple
                    collapse-tags
                    :multiple-limit="6"
                    v-model="selectedCompanywelfare"
                    placeholder="请选择"
                    disabled
                    @change="handleGetwelfare"
                  >
                    <el-option
                      v-for="item in CompanywelfareList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <span style="color: red; margin-left: 5px">*</span>
                </div>
              </div>
            </div>
            <div class="textareabox">
              <p style="margin-right: 6px;color: #333;">公司简介</p>
              <el-input
                disabled
                type="textarea"
                :rows="5"
                resize="none"
                placeholder="请输入内容"
                v-model="companyInfo"
              ></el-input>
              <span style="color: red; margin-left: 5px; line-height: 117px"
                >*</span
              >
            </div>
          </div>
          <div class="positionMsg">
            <p class="title">职位信息</p>
            <div class="companyTexts">
              <div>
                <div style="margin-right: 54px">
                  <span>职位名称</span>
                  <el-input
                    v-model="createpositionName"
                    placeholder="请输入内容"
                  ></el-input>
                  <span style="color: red; margin-left: 5px">*</span>
                </div>
                <div style="margin-right: 54px">
                  <span>职能分类</span>
                  <el-cascader
                    v-model="showFun"
                    :props="{ value: 'id', label: 'name' }"
                    :options="functionList"
                    @change="handleSelectFunname"
                  ></el-cascader>
                  <span style="color: red; margin-left: 5px">*</span>
                </div>
                <div class="cascaderbox">
                  <span>工作地点</span>
                  <!-- {expandTrigger: 'hover', value: 'code', label: 'name', children:'cities', multiple:true,checkStrictly:true} -->
                  <!-- {expandTrigger: 'hover', value: 'code', label: 'name', children:'cities'} -->
                  <el-cascader
                    v-model="showPlace"
                    :props="PropsObj"
                    :options="workPlace"
                    @change="handleselectworkPlace"
                  ></el-cascader>
                  <span style="color: red; margin-left: 5px">*</span>
                </div>
              </div>
            </div>
            <div class="companyTexts">
              <div>
                <div v-if="isSelectedWorkYears" style="margin-right: 54px">
                  <span>工作年限</span>
                  <el-select
                    v-model="selectedWorkYears"
                    placeholder="请选择"
                    @change="handleSelectworkYears"
                  >
                    <el-option
                      v-for="item in workYears"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <span style="color: red; margin-left: 5px">*</span>
                </div>
                <div style="margin-right: 54px">
                  <span>学历要求</span>
                  <el-select
                    v-model="selectedEducation"
                    placeholder="请选择"
                    @change="handleSelectEduc"
                  >
                    <el-option
                      v-for="item in EducationList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <span style="color: red; margin-left: 5px">*</span>
                </div>
                <div class="select" style="position: relative">
                  <p style="margin-right: 6px;color: #333;">薪资范围</p>
                  <div class="select-input">
                    <el-input placeholder="请输入" style="width: 75px!important;height: 32px;" v-model="salary_min" @blur="blur_num('salary_min')"  maxlength="3"></el-input>
                    <span style="margin: 0 6px;">~</span>
                    <el-input placeholder="请输入" style="width: 75px!important;height: 32px;" v-model="salary_max" @blur="blur_num('salary_max')" maxlength="3"></el-input>
                  </div>
                  <el-select v-model="salary_type" style="width:80px;margin-left: 5px;">
                    <el-option label="K/月" value="2"></el-option>
                    <el-option label="元/天" value="3"></el-option>
                  </el-select>
                  <span style="color: red; margin-left: 5px">*</span>
                  <el-input v-if="salary_type!=3" style="width: 75px!important;height: 32px;margin-left: 5px;" min="12" @blur="getMinVal" type="number" v-model="salary_cap"></el-input>
                  <span v-if="salary_type!=3" style="margin-left: 5px">薪</span>
                  <p
                    v-if="isRight"
                    style="
                      color: red;
                      font-szie: 14px;
                      position: absolute;
                      right: 0;
                      top: 35px;
                      margin-bottom: 20px;
                    "
                  >
                    薪资格式填写错误，请重新填写
                  </p>
                </div>
              </div>
            </div>
            <div class="textareabox">
              <p style="margin-right: 6px;color: #333;">职位描述</p>
              <el-input
                type="textarea"
                :rows="5"
                resize="none"
                show-word-limit
                placeholder="请输入内容"
                v-model="positionInfo"
                @input="regValue"
              ></el-input>
              <span style="color: red; margin-left: 5px; line-height: 117px"
                >*</span
              >
            </div>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button class="bottomBtn" @click="handlecloseposition"
            >取 消</el-button
          >
          <el-button
            class="bottomBtn"
            style="background-color: #0077FF;color: #fff;"
            type="primary"
            @click="handleAddPosition"
            >确 定</el-button
          >
        </span>
      </el-dialog>

      <!-- 公司弹窗 -->
      <el-dialog
        :title="dialogtitle"
        :visible.sync="isShowCreatedCompany"
        width="56%"
        center
        :close-on-click-modal="false"
        class="createCompany"
      >
        <div class="createBox">
          <div class="companyMsg">
            <div class="companyTexts">
              <div>
                <div style="margin-right: 74px">
                  <span>公司名称</span>
                  <el-input
                    v-model="companyDialogName"
                    placeholder="请输入内容"
                  ></el-input>
                  <span style="color: red; margin-left: 5px">*</span>
                </div>
                <div style="margin-right: 74px">
                  <span>公司简称</span>
                  <el-input
                    v-model="company_short"
                    placeholder="请输入内容"
                  ></el-input>
                  <span style="color: red; margin-left: 5px">*</span>
                </div>
                <div class="uploadimg">
                  <span>公司logo</span>
                  <uploadimg
                    style="display: inline-block; margin-left: 18px"
                    :img="companyLogo"
                    :size="{ width: 113, height: 40 }"
                    @getimg="seritems($event)"
                  ></uploadimg>
                  <span style="color: red; margin-left: 5px">*</span>
                </div>
              </div>
            </div>
            <div class="companyTexts">
              <div>
                <div style="margin-right: 48px">
                  <span>对外显示名称</span>
                  <el-input
                    v-model="foreignDialogName"
                    placeholder="请输入内容"
                  ></el-input>
                  <span style="color: red; margin-left: 5px">*</span>
                </div>
                <div>
                  <span>公司规模</span>
                  <el-select
                    v-model="companyScale"
                    placeholder="请选择"
                    @change="handleselectcompanyScale"
                  >
                    <el-option
                      v-for="item in companyScaleList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <span style="color: red; margin-left: 5px">*</span>
                </div>
              </div>
            </div>
            <div class="textareabox" style="margin-bottom: 20px">
              <p style="margin-right: 6px">公司简介</p>
              <el-input
                type="textarea"
                :rows="5"
                maxlength="500"
                show-word-limit
                resize="none"
                placeholder="请输入内容"
                v-model="companyDialogInfo"
              ></el-input>
              <span style="color: red; margin-left: 5px; line-height: 117px"
                >*</span
              >
            </div>
            <!-- 公司福利 -->
            <div class="companyTexts companytag">
              <div>
                <div style="margin-right: 48px">
                  <span>公司福利</span>
                  <el-select
                    multiple
                    collapse-tags
                    :multiple-limit="6"
                    @change="handleGetwelfare"
                    v-model="selectedCompanywelfare"
                  >
                    <el-option
                      v-for="item in CompanywelfareList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <span
                    style="
                      color: red;
                      margin-left: 5px;
                    "
                    >*</span
                  >
                  <el-tag
                    v-for="(item, index) in selectedCompanywelfare"
                    :key="index"
                    :disable-transitions="false"
                    @close="handleClose(item)"
                    >{{ eachitem(item) }}</el-tag
                  >
                </div>
              </div>
            </div>
            <div class="companyTexts">
              <div>
                <div style="margin-right: 48px">
                  <span>融资阶段</span>
                  <el-input
                    v-model="companyFinancing"
                    placeholder="请输入内容"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="bottomBtn" @click="isShowCreatedCompany = false"
            >取 消</el-button
          >
          <el-button
            class="bottomBtn"
            style="background-color: #0077ff;color: #fff;"
            type="primary"
            @click="handleChangeCompanyMsg"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import cityList from "../../../static/city.json";
import TablePage from "@/components/TablePagePositionList";
import TablePageCompany from "@/components/TablePageCompanyList";
import PositionApi from "@/api/PositionModule";
import PublicApi from "@/api/PublicModule";
import uploadimg from "@/components/uploadimg/index";
export default {
  components: { uploadimg, TablePage, TablePageCompany },
  data() {
    return {
      websockFlag: true, //开关变量
      isShowAdd: false,
      isdisabled: false,
      // 创建公司的名称
      companyDialogName: "",
      //公司简称
      company_short:"",
      map_code:'',
      // 创建公司对外显示名称
      foreignDialogName: "",
      // 创建公司logo
      companyLogo: "",
      // 创建公司的简介
      companyDialogInfo: "",
      // 创建公司选中的福利
      selectedCompanywelfare: "",
      // 创建公司的融资阶段
      companyFinancing: "",
      // 对外显示名称
      foreignName: "",
      // 融资阶段
      financingStage: "",
      // 公司规模
      companyScale: "",
      // 公司简介
      companyInfo: "",
      // 发布职位名称
      createpositionName: "",
      // 职位描述
      positionInfo: "",
      // 公司福利
      CompanywelfareList: [],
      // 公司规模列表
      companyScaleList: [],
      // 工作年限
      workYears: [],
      // 学历列表
      EducationList: [],
      // 职能分类
      functionList: [],
      // 工作地点
      workPlace: [],
      // 选中的学历
      selectedEducation: "",
      // 选中的工作年限
      selectedWorkYears: "",
      // 是否显示工作年限
      isSelectedWorkYears: true,
      // 选中的职能分类
      selectFunname: "",
      // 选中职能
      selectedFun: "",
      // 选中的工作地点
      selectPlace: "",
      // 公司弹窗名称
      dialogtitle: "",
      // 职位弹窗名称
      dialogposition: "",
      // 是否展示创建公司弹窗
      isShowCreatedCompany: false,
      // 是否展示发布职位弹窗
      isShowCreatedPosition: false,
      //是否是HR,不是HR就是猎头
      isHR: false,
      // 默认选中的tab标签
      activeName: '',
      //   搜索的职位名称
      searchpositionname: "",
      // 搜索的公司名称
      searchcompanyname: "",
      isposition: true,
      // 职位列表数据
      positionList: [],
      // 公司列表数据
      companyList: [],
      // 职位状态
      positionStatus: "on",
      // 职位细分类
      case: '',
      currentCompanyId: "",
      createCompanyList: [],
      // 选中的公司
      selectedCompany: "",
      editCompanyId: "",
      // 图片域名
      imgHost: "",
      // 图片路径
      imgpath: "",
      // 客户类型
      customerType: "",
      // 选中的省份
      selectedprovince: "",
      mapCode: "",
      address: [],
      // 展示的工作地点
      showPlace: "",
      // 展示的职能
      showFun: "",
      editPositionId: "",
      selectFun: "",
      salary_min: "",
      salary_max: "",
      salary_type:'',
      salary_cap:'',
      type_id:'',
      isshowimg: true,
      isSearch: false,
      isRight: false,
      showTags: [],
      PropsObj: {},
      positionTypeVisible: false, //职位类型弹窗
      page_cu:{
        8:{current_page: 1,per_page: 6},
        9999:{current_page: 1,per_page: 6}
      },
      CompanyPage: {
        current_page: 1,
        per_page: 6,
      },
      isOther:false,
      is_double:null,
      handleChildList:[
        // {childHandleName: "双选会", isActive: true, value: "8",years:8,identify:8},
        {childHandleName: "暂停职位", isActive: true, value: "9999",identify: "all"}
      ],
      isrefresh:true,//是否刷新职位
      typeoryears:'type',
      holCitys:[]
    };
  },
  computed: {
    handleChildinfo(){
      return this.handleChildList.filter(item => item.identify!=='all');
    },
    pages(){
      return this.page_cu[this.case];
    }
  },
  created() {
    let account = JSON.parse(localStorage.getItem("account"));
    let {is_double, member_type} = account;
    this.is_double = is_double;
    this.customerType = member_type;
    this.isHR = member_type==='hr'?true:false;
    this.getPositionTag();
    this.handleGetPublicData();
    this.getCitys();
    this.getholCitys();
  },
  watch: {
    isShowCreatedPosition() {
      if (!this.isShowCreatedPosition && this.dialogposition == "发布职位") {
        var cascaderbox = document.getElementsByClassName("cascaderbox")[0];
        var inhtml = cascaderbox.getElementsByClassName("el-cascader__tags")[0];
        inhtml.innerHTML = "";
      }
    }
  },
  filters: {
    getNum: function (value) {
      return Math.ceil(value);
    },
  },
  methods: {
    getMinVal(){
      if(this.salary_cap<12){
        this.salary_cap = 12
      }
    },
    blur_num(model){
      this[model] = isNaN(parseInt(this[model]))?0:parseInt(this[model]);
      this.isRight = false;
    },
    getCitys() {
      // 获取七牛城市数据
      PublicApi.getCity()
        .then((res) => {
          this.workPlace = res.data.provinces;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    regValue(val) {
      const emailReg = /[\@]/;
      if (emailReg.test(val)) {
        this.$message.error("职位描述不符合规范，请重新输入");
        this.positionInfo = val.substring(0, val.length - 1);
      }
    },
    getholCitys(){
      PublicApi.getholCitys()
        .then((res) => {
          this.holCitys = res.data.provinces;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 发布职位中添加新的公司
    handleOpenAddCompany() {
      // 清空表单内容
      this.companyDialogName = "";
      this.company_short = "";
      this.foreignDialogName = "";
      this.companyDialogInfo = "";
      this.companyFinancing = "";
      this.companyScale = "";
      this.selectedCompanywelfare = "";
      this.companyLogo = "";
      this.isShowCreatedCompany = true;
      this.isShowCreatedPosition = false;
      this.dialogtitle = "新建公司";
    },

    // 获取猎头维护的公司列表(联调完成)
    handleGetReadonlyCompany() {
      let params = "?detail=1";
      PositionApi.getCompanyList(params)
        .then((res) => {
          this.createCompanyList = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取当前HR所属公司信息
    handleGetHrMsg() {
      PositionApi.getUserCompanyMsg()
        .then((res) => {
          this.selectedCompany = res.data.data.company_name;
          this.foreignName = res.data.data.show_name;
          this.companyLogo = res.data.data.logo.replace(
            /^(?:[^/]*\/){3}(.*)$/,
            "$1"
          );
          this.financingStage = res.data.data.capitalization;
          this.companyScale = res.data.data.scale;
          let arr = [];
          res.data.data.treatments.forEach((item) => {
            arr.push(item.treatment_name);
          });
          this.selectedCompanywelfare = arr;
          this.companyInfo = res.data.data.intro;
          this.currentCompanyId = res.data.data.id;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handlecloseposition() {
      this.isRight = false;
      this.isShowCreatedPosition = false;
    },
    // 获取选中的公司信息
    handlechangecompany(e) {
      this.selectedCompany = e;
      // 获取当前公司的信息
      PositionApi.getEditCompanyMsg(this.selectedCompany)
        .then((res) => {
          this.currentCompanyId = res.data.data.id;
          this.foreignName = res.data.data.show_name;
          this.companyLogo = res.data.data.logo.replace(
            /^(?:[^/]*\/){3}(.*)$/,
            "$1"
          );
          this.financingStage = res.data.data.capitalization;
          this.companyScale = res.data.data.scale;
          let arr = [];
          res.data.data.treatments.forEach((item) => {
            arr.push(item.treatment_name);
          });
          this.selectedCompanywelfare = arr;
          this.companyInfo = res.data.data.intro;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 上传图片
    seritems(e) {
      console.log(e);
      // 域名
      this.imgHost = e.data.host;
      // 图片路径
      this.imgpath = e.data.image;
      // 完整地址
      this.companyLogo = e.data.image;
    },
    // 获取公共表单数据
    handleGetPublicData() {
      PublicApi.getPublicFormList()
        .then((res) => {
          this.CompanywelfareList = res.data.data.treatments;
          this.functionList = res.data.data.positions;
          this.companyScaleList = res.data.data.scale;
          this.EducationList = res.data.data.educations;
          this.workYears = res.data.data.years.filter(item => item.name!='应届生');
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // tab切换
    handleChangeTabs(tab) {
      if (tab.name == "third") {
        this.isposition = false;
        this.handleGetCompany();
      } else {
        this.case = tab.name;
        if (this.case === "9999") {
          this.positionStatus = "off";
        } else {
          this.positionStatus = "on";
          this.typeoryears = tab.$attrs.years?'years':'type';
        }
        this.isposition = true;
        this.handleGetPosition();
      }

    },
    // 职位列表分页
    handleChangeCurrentPage(e) {
      this.page_cu[this.case].current_page = e;
      this.handleGetPosition();
    },
    // 公司列表分页
    handleChangeCurrentPageCompany(e) {
      this.CompanyPage.current_page = e;
      this.handleGetCompany();
    },
    // 职位名称重置按钮
    handleResetPositionName() {
      this.searchpositionname = "";
      this.map_code = "";
      this.page_cu[this.case].current_page = 1;
      this.handleGetPosition();
    },
    // 公司名称搜索(联调完成)
    handleSearchCompanyName() {
      this.CompanyPage.current_page = 1;
      this.handleGetCompany();
    },
    // 公司名称重置(联调完成)
    handleResetCompany() {
      this.searchcompanyname = "";
      this.CompanyPage.current_page = 1;
      this.handleGetCompany();
    },
    //查询
    query() {
      this.page_cu[this.case].current_page = 1;
      this.handleGetPosition();
    },
    getPositionTag(){
      PositionApi.getPositionTag()
        .then((res) => {
          let handleChildList = [];
          let page_cu = {};
          if(res.data.status===0){
            res.data.data.forEach(element => {
              handleChildList.push({
                childHandleName:element.name,
                isActive: true,
                value:element.id.toString(),
                identify:element.identify
              })
              page_cu[element.id] = {
                current_page: 1,
                per_page: 6
              }
            });
            this.page_cu = {...page_cu,...this.page_cu};
            this.handleChildList = [...handleChildList,...this.handleChildList];
            this.activeName = this.handleChildList[0].value;
            this.case = this.activeName;
            this.typeoryears = this.handleChildList[0].years?'years':'type';
            let other = this.handleChildList.filter(item => item.value=="9999");
            this.isOther = !!other.length;
            this.handleGetPosition();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**职位相关*/
    // 获取职位列表数据
    handleGetPosition() {
      let params = `?search=${this.searchpositionname}&map_code=${this.map_code}&status=${
        this.positionStatus
      }&${this.typeoryears}=${this.case}&page=${
        this.page_cu[this.case].current_page
      }&limit=${this.page_cu[this.case].per_page}`;
      PositionApi.getPositionList(params)
        .then((res) => {
          let { data, current_page, last_page, total } = res.data;
          let obj = { current_page, last_page, total };
          this.positionList = data;
          this.page_cu[this.case] = {
            ...this.page_cu[this.case],
            ...obj,
          }
        })
        .catch((err) => {
          if(err.status===403){
            this.$message.error('暂时没有权限访问');
          }
          console.log(err);
        });
    },
    errMessage(err){
      if(err.status===404){
        if(err.data.status===201){
          this.$message.error('您没有该职位的操作权限');
        }
      }
    },
    handleStopOrPosition(e){
      let {id, years} = e;
      let years_id = years==1||years==8?years:5;
      if(this.positionStatus=="on"){
        this.handleStopPosition(id, years_id);
      }else{
        this.handleOpenPosition(id, years_id);
      }
    },
    // 暂停职位
    handleStopPosition(id, years_id) {
      this.$confirm(
        "确认后，该职位将从在招中移除并下架",
        "您正在暂停该职位，请确认是否继续？",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let params = {
            active_status: false
          };
          PositionApi.editPositionMsg(id, params)
            .then((res) => {
              this.$message({
                type: "success",
                message: "暂停成功!",
              });
              this.positionStatus = "on";
              if(this.positionList.length===1){
                let { current_page } = this.page_cu[this.case];
                current_page = current_page-1;
                if(current_page===0){
                  current_page = 1
                }
                this.page_cu[this.case]['current_page'] = current_page;
              }
              this.handleGetPosition();
            })
            .catch((err) => {
              this.errMessage(err);
              console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消暂停",
          });
        });
    },
    // 开启职位
    handleOpenPosition(id, years_id) {
      this.$confirm(
        "确认后，该职位将从暂停职位中移除并上架",
        "您正在启用该职位，请确认是否继续？",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let params = {
            active_status: true
          };
          PositionApi.editPositionMsg(id, params)
            .then((res) => {
              this.$message({
                type: "success",
                message: "启用成功!",
              });
              this.positionStatus = "off";
              if(this.positionList.length===1){
                let { current_page } = this.page_cu[this.case];
                current_page = current_page-1;
                if(current_page===0){
                  current_page = 1
                }
                this.page_cu[this.case]['current_page'] = current_page;
              }
              this.handleGetPosition();
            })
            .catch((err) => {
              this.errMessage(err);
              console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消启用",
          });
        });
    },

    //打开职位类别
    handleOpenCreate() {
      this.positionTypeVisible = true;
    },
    // 打开发布职位弹窗
    handlePublish(scope) {
      let { value, years, identify} = scope;
      this.isSelectedWorkYears = identify==="SHEZHAO" ? true : false;
      this.PropsObj = {
        expandTrigger: "hover",
        value: "code",
        label: "name",
        children: "cities",
        multiple: true,
        checkStrictly: true,
      };
      if (this.isHR === false) {
        this.isdisabled = false;
      } else {
        this.isdisabled = true;
      }
      this.isRight = false;
      this.isshowimg = true;
      this.isShowCreatedPosition = true;
      this.isShowAdd = true;
      this.dialogposition = "发布职位";
      // 清空标签内容
      this.companyInfo = "";
      this.selectedCompany = "";
      this.foreignName = "";
      this.createpositionName = "";
      // this.selectFunname = "";
      // this.selectPlace = "";
      this.selectedWorkYears = identify==='SHEZHAO' ? "" : this.identifyVal(identify);
      this.selectedEducation = "";
      this.salary_min = "";
      this.salary_max = "";
      this.positionInfo = "";
      this.selectedCompanywelfare = "";
      this.companyScale = "";
      this.companyLogo = "";
      this.financingStage = "";
      this.showPlace = "";
      this.showFun = "";
      this.salary_type = '2';
      this.salary_cap = '';
      this.type_id = years?'years':value;
      this.typeoryears = years?'years':'type';
      // 获取猎头维护的公司列表
      if (this.isHR === false) {
        this.handleGetReadonlyCompany();
      } else {
        this.handleGetHrMsg();
      }
    },
    identifyVal(val){
      let default_val;
      if(val==='SHIXI'){
        default_val = 7
      }else if(val==='XIAOZHAO'){
        default_val = 1
      }else if(val===8){
        default_val = 8
      }
      return default_val;
    },
    // 职位编辑弹窗
    handleEditPosition(e) {
      this.PropsObj = {
        expandTrigger: "hover",
        value: "code",
        label: "name",
        children: "cities",
      };
      this.isRight = false;
      this.isShowAdd = false;
      this.isdisabled = true;
      this.selectedCompany = "";
      this.foreignName = "";
      this.companyLogo = "";
      this.financingStage = "";
      this.companyScale = "";
      this.companyInfo = "";
      this.selectedCompanywelfare = "";
      this.editPositionId = e;
      this.isShowCreatedPosition = true;
      this.dialogposition = "编辑职位";
      if (this.isHR === false) {
        this.handleGetReadonlyCompany();
      } else {
        this.handleGetHrMsg();
      }
      // 获取要编辑的职位详情
      PositionApi.getPositionDetails(this.editPositionId)
        .then((res) => {
          // 公司信息部分
          this.selectedCompany = res.data.data.company_info.company_name;
          this.foreignName = res.data.data.company_info.show_name;
          this.companyLogo = res.data.data.company_info.logo.replace(
            /^(?:[^/]*\/){3}(.*)$/,
            "$1"
          );
          this.financingStage = res.data.data.company_info.capitalization;
          this.companyScale = res.data.data.company_info.scale;
          let arr = [];
          res.data.data.company_info.treatments.forEach((item) => {
            arr.push(item.treatment_name);
          });
          this.selectedCompanywelfare = arr;
          this.companyInfo = res.data.data.company_info.overview;

          // 职位信息部分
          this.createpositionName = res.data.data.position_name;
          let funarr = [];
          funarr.push(res.data.data.position_field.field.field_id);
          funarr.push(res.data.data.position_field.position_id);
          this.showFun = funarr;
          let placearr = [];
          placearr.push(
            (Math.floor(res.data.data.map_code / 100) * 100).toString()
          );
          placearr.push(res.data.data.map_code.toString());
          this.showPlace = placearr;
          this.selectPlace = res.data.data.city;
          this.selectedprovince = res.data.data.province;
          this.selectedWorkYears = res.data.data.years;
          this.selectedEducation = res.data.data.educ;
          this.salary_min = res.data.data.salary_min;
          this.salary_max = res.data.data.salary_max;
          this.salary_type = res.data.data.salary_type.toString();
          this.salary_cap = res.data.data.salary_cap;
          this.positionInfo = res.data.data.intro;
          this.isSelectedWorkYears = res.data.data.years == 1||res.data.data.years == 8||res.data.data.years == 7 ? false : true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 提交发布或编辑职位信息***大神代码操作勿动
    handleAddPosition() {
      if (
        parseInt(this.salary_min) < 0||
        parseInt(this.salary_max) <= parseInt(this.salary_min) ||
        parseInt(this.salary_max) > 999 ||
        parseInt(this.salary_min) > 999 ||
        String(this.salary_min).indexOf(".") != -1 ||
        String(this.salary_max).indexOf(".") != -1
      ) {
        this.isRight = true;
      } else {
        this.isRight = false;
        if (this.dialogposition === "发布职位") {
          if (!this.websockFlag) {
            this.$message("正在请求中,请勿重复操作!");
            return;
          }
          // 发布职位
          if (this.isHR === false) {
            // 猎头的逻辑
            if (
              this.selectedCompany === "" ||
              this.foreignName === "" ||
              this.companyLogo === "" ||
              this.companyScale === "" ||
              this.selectedCompanywelfare.toString() === "" ||
              this.companyInfo === ""
            ) {
              this.$message({
                showClose: true,
                message:
                  "您的公司信息未完善请返回公司列表新增/编辑完善后在发布职位，谢谢",
                type: "error",
              });
            } else if (
              this.createpositionName === "" ||
              this.selectFunname === "" ||
              !this.address.length ||
              this.selectedWorkYears === "" ||
              this.selectedEducation === "" ||
              this.positionInfo === "" ||
              this.salary_max === "" ||
              this.salary_min === ""
            ) {
              this.$message({
                showClose: true,
                message: "您的职位信息不完整，请完善，谢谢",
                type: "error",
              });
            } else {
              let params = {
                province: this.selectedprovince,
                position_name: this.createpositionName,
                position_field_id: this.selectFunname,
                position_id: this.selectFun,
                address: this.address,
                // city: this.selectPlace,
                years: this.selectedWorkYears,
                educ: this.selectedEducation,
                salary_min: this.salary_min,
                salary_max: this.salary_max,
                salary_type: this.salary_type,
                salary_cap:this.salary_cap?this.salary_cap:12,
                // map_code: this.mapCode,
                intro: this.positionInfo,
                company_info: {
                  customer_type: this.customerType,
                  company_id: this.currentCompanyId,
                },
              };
              let ad_params = {};
              if(this.type_id!=='years'){
                ad_params = {
                  type_id:this.type_id
                }
              }
              this.websockFlag = false;
              PositionApi.addPositionMsg(Object.assign(params,ad_params))
                .then((res) => {
                  setTimeout(() => {
                    this.websockFlag = true;
                  }, 1000);
                  // 提示创建成功
                  // 重新加载职位列表
                  this.activeName = this.type_id==='years'?'8':this.type_id;
                  this.case = this.activeName;
                  this.handleGetPosition();
                  this.selectFunname = "";
                  this.selectFun = "";
                  this.showFun = "";
                  this.selectedprovince = "";
                  this.showPlace = "";
                  this.isShowCreatedPosition = false;
                  this.positionTypeVisible = false;
                })
                .catch((err) => {
                  this.websockFlag = true;
                  console.log(err);
                });
            }
          } else {
            // HR逻辑
            if (
              this.selectedCompany === "" ||
              this.companyLogo === "" ||
              this.companyScale === "" ||
              this.selectedCompanywelfare.toString() === "" ||
              this.companyInfo === ""
            ) {
              this.$message({
                showClose: true,
                message:
                  "您的公司信息未完善请前往我的资料公司列表编辑完善后发布职位，谢谢",
                type: "error",
              });
            } else if (
              this.createpositionName === "" ||
              this.selectFunname === "" ||
              !this.address.length ||
              this.selectedWorkYears === "" ||
              this.selectedEducation === "" ||
              this.positionInfo === "" ||
              this.salary_max === "" ||
              this.salary_min === ""
            ) {
              this.$message({
                showClose: true,
                message: "您的职位信息不完整，请完善，谢谢",
                type: "error",
              });
            } else {
              let params = {
                province: this.selectedprovince,
                position_name: this.createpositionName,
                position_field_id: this.selectFunname,
                position_id: this.selectFun,
                address: this.address,
                // city: this.selectPlace,
                years: this.selectedWorkYears,
                educ: this.selectedEducation,
                salary_min: this.salary_min,
                salary_max: this.salary_max,
                salary_type: this.salary_type,
                salary_cap:this.salary_cap?this.salary_cap:12,
                // map_code: this.mapCode,
                intro: this.positionInfo,
                company_info: {
                  customer_type: this.customerType,
                  company_id: this.currentCompanyId,
                },
                province: this.selectedprovince,
              };
              let ad_params = {};
              if(this.type_id!=='years'){
                ad_params = {
                  type_id:this.type_id
                }
              }
              this.websockFlag = false;
              PositionApi.addPositionMsg(Object.assign(params,ad_params))
                .then((res) => {
                  setTimeout(() => {
                    this.websockFlag = true;
                  }, 1000);
                  this.$message.success("创建成功");
                  this.activeName = this.type_id==='years'?'8':this.type_id;
                  this.case = this.activeName;
                  this.handleGetPosition();
                  this.isShowCreatedPosition = false;
                  this.positionTypeVisible = false;
                })
                .catch((err) => {
                  this.websockFlag = true;
                  console.log(err);
                });
            }
          }
        } else {
          // 编辑职位
          if (this.isHR === false) {
            if (
              this.selectedCompany === "" ||
              this.foreignName === "" ||
              this.companyLogo === "" ||
              this.companyScale === "" ||
              this.selectedCompanywelfare.toString() === "" ||
              this.companyInfo === ""
            ) {
              this.$message({
                showClose: true,
                message:
                  "您的公司信息未完善请返回公司列表新增/编辑完善后在发布职位，谢谢",
                type: "error",
              });
            } else if (
              this.createpositionName === "" ||
              this.showFun === "" ||
              this.showPlace === "" ||
              this.selectedWorkYears === "" ||
              this.selectedEducation === "" ||
              this.positionInfo === "" ||
              this.salary_max === "" ||
              this.salary_min === ""
            ) {
              this.$message({
                showClose: true,
                message: "您的职位信息不完整，请完善，谢谢",
                type: "error",
              });
            } else {
              if (this.selectFunname === "") {
                this.selectFunname = this.showFun[0];
              } else {
                this.selectFunname = this.selectFunname;
              }
              if (this.selectFun === "") {
                this.selectFun = this.showFun[1];
              } else {
                this.selectFun = this.selectFun;
              }
              this.mapCode = this.showPlace[1];
              let params = {
                province: this.selectedprovince,
                position_name: this.createpositionName,
                position_field_id: this.selectFunname,
                position_id: this.selectFun,
                city: this.selectPlace,
                years: this.selectedWorkYears,
                educ: this.selectedEducation,
                salary_min: this.salary_min,
                salary_max: this.salary_max,
                salary_type: this.salary_type,
                salary_cap:this.salary_cap?this.salary_cap:12,
                map_code: this.mapCode,
                intro: this.positionInfo,
                company_info: {
                  customer_type: this.customerType,
                  company_id: this.currentCompanyId,
                },
              };
              PositionApi.editPositionMsg(this.editPositionId, params)
                .then((res) => {
                  this.$message.success("编辑成功");
                  this.handleGetPosition();
                  this.isShowCreatedPosition = false;
                })
                .catch((err) => {
                  this.errMessage(err);
                  console.log(err);
                });
            }
          } else {
            if (
              this.selectedCompany === "" ||
              this.companyLogo === "" ||
              this.companyScale === "" ||
              this.selectedCompanywelfare.toString() === "" ||
              this.companyInfo === ""
            ) {
              this.$message({
                showClose: true,
                message:
                  "您的公司信息未完善请返回公司列表新增/编辑完善后在发布职位，谢谢",
                type: "error",
              });
            } else if (
              this.createpositionName === "" ||
              this.showFun === "" ||
              this.showPlace === "" ||
              this.selectedWorkYears === "" ||
              this.selectedEducation === "" ||
              this.positionInfo === "" ||
              this.salary_max === "" ||
              this.salary_min === ""
            ) {
              this.$message({
                showClose: true,
                message: "您的职位信息不完整，请完善，谢谢",
                type: "error",
              });
            } else {
              if (this.selectFunname === "") {
                this.selectFunname = this.showFun[0];
              } else {
                this.selectFunname = this.selectFunname;
              }
              if (this.selectFun === "") {
                this.selectFun = this.showFun[1];
              } else {
                this.selectFun = this.selectFun;
              }
              this.mapCode = this.showPlace[1];
              let params = {
                province: this.selectedprovince,
                position_name: this.createpositionName,
                position_field_id: this.selectFunname,
                position_id: this.selectFun,
                city: this.selectPlace,
                years: this.selectedWorkYears,
                educ: this.selectedEducation,
                salary_min: this.salary_min,
                salary_max: this.salary_max,
                salary_type: this.salary_type,
                salary_cap:this.salary_cap?this.salary_cap:12,
                map_code: this.mapCode,
                intro: this.positionInfo,
                company_info: {
                  customer_type: this.customerType,
                  company_id: this.currentCompanyId,
                },
              };
              PositionApi.editPositionMsg(this.editPositionId, params)
                .then((res) => {
                  this.$message.success("编辑成功");
                  this.handleGetPosition();
                  this.isShowCreatedPosition = false;
                })
                .catch((err) => {
                  this.errMessage(err);
                  console.log(err);
                });
            }
          }
        }
      }
      //
    },
    refresh8(id){//刷新双选会职位
      // isrefresh
      if(this.isrefresh){
        this.isrefresh = false;
        PositionApi.refresh8List(id)
        .then((res) => {
          if(res.data.status==0){
            this.$message.success("刷新成功");
          }else{
            this.$message.error("刷新失败");
          }
          this.isrefresh = true;
        })
        .catch((err) => {
          console.log(err);
        });
      }
    },
    // 获取选中的职能分类名称
    handleSelectFunname(e) {
      this.showFun = e;
      this.selectFunname = e[0];
      this.selectFun = e[1];
    },
    // 获取选中的工作地点
    handleselectworkPlace(e) {
      var that = this;
      // e.forEach((item, i) => {
      //   if (item.length == 1) {
      //     e.splice(i, 1);
      //   }
      // });
      if (e.length > 10) {
        this.$message({
          showClose: true,
          message: "最多不超过10个城市",
          type: "error",
        });
        var e = this.newarr.slice(0, 10);
      } else {
        this.newarr = e;
        var e = e;
      }
      this.showPlace = e;
      let arr = [];
      if (this.dialogposition == "发布职位") {
        var cascaderbox = document.getElementsByClassName("cascaderbox")[0];
        var inhtml = cascaderbox.getElementsByClassName("el-cascader__tags")[0];
        var indiv =
          "<div style='padding-left: 15px;'>已选择个" +
          this.showPlace.length +
          "城市</div>";
        inhtml.innerHTML = indiv;
        if (this.showPlace.length < 1) {
          inhtml.innerHTML = "";
        }
        this.showPlace.forEach((item, index) => {
          this.workPlace.forEach((el, i) => {
            if (item[0] === el.code) {
              arr.push({
                province: el.name,
                city: that.cityFun(item[1], el.cities).name,
                map_code: that.cityFun(item[1], el.cities).code,
              });
            }
          });
        });
        that.address = arr;
      }
      if (this.dialogposition == "编辑职位") {
        this.mapCode = e[1];
        this.workPlace.forEach((item, index) => {
          if (e[0] === item.code) {
            this.selectedprovince = item.name;
            arr = item.cities;
          }
        });
        arr.forEach((item, index) => {
          if (e[1] === item.code) {
            this.selectPlace = item.name;
          }
        });
      }
    },
    //省市分类多级查询
    cityChange(e) {
      this.map_code = this.changeArray(e)[
        this.changeArray(e).length - 1
      ];
    },
    //去除0
    changeArray(arr) {
      if (arr) {
        return arr[0] == "0" ? [] : arr;
      }
      return arr;
    },
    cityFun(item, el) {
      var obj = {};
      el.forEach((e) => {
        if (item == e.code) {
          obj = {
            code: e.code,
            name: e.name,
          };
        }
      });
      return obj;
    },
    // 获取选中的工作年限
    handleSelectworkYears(e) {
      this.selectedWorkYears = e;
    },
    // 获取选中的学历要求
    handleSelectEduc(e) {
      this.selectedEducation = e;
    },

    /**                                                         公司相关                                   */
    // 获取公司列表数据
    handleGetCompany() {
      let params = `?search=${this.searchcompanyname}&page=${this.CompanyPage.current_page}&limit=${this.CompanyPage.per_page}`;
      PositionApi.getCompanyList(params)
        .then((res) => {
          let { data, current_page, last_page, total } = res.data;
          let obj = { current_page, last_page, total };
          this.companyList = data;
          this.CompanyPage = { ...this.CompanyPage, ...obj };
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 打开创建公司弹窗
    handleOpenCreateCompany() {
      this.isShowCreatedCompany = true;
      this.dialogtitle = "新建公司";
      // 清空表单内容
      this.companyDialogName = "";
      this.company_short = "";
      this.foreignDialogName = "";
      this.companyDialogInfo = "";
      this.companyFinancing = "";
      this.companyScale = "";
      this.selectedCompanywelfare = "";
      this.companyLogo = "";
    },
    // 获取选中的公司规模
    handleselectcompanyScale(e) {
      this.companyScale = e;
    },
    // 提交创建获取编辑的公司信息
    handleChangeCompanyMsg() {
      if (
          this.companyLogo == "" ||
          this.companyDialogName == "" ||
          this.company_short == "" ||
          this.foreignDialogName == "" ||
          this.companyDialogInfo == "" ||
          this.companyScale == "" ||
          this.selectedCompanywelfare == ""
        ) {
          // 提示用户请完善信息
          this.$message.error("请完善公司信息");
          return
        }
        let params = {
          logo: this.companyLogo,
          company_name: this.companyDialogName,
          company_short:this.company_short,
          show_name: this.foreignDialogName,
          intro: this.companyDialogInfo,
          capitalization: this.companyFinancing,
          scale: this.companyScale,
          treatments: this.selectedCompanywelfare,
        };
      if (this.dialogtitle === "编辑公司") {
        PositionApi.SendEditCompanyMsg(this.editCompanyId, params)
          .then((res) => {
            this.$message.success("编辑成功");
            this.isShowCreatedCompany = false;
            this.handleGetCompany();
          })
          .catch((err) => {
            console.log(err);
            this.$message.error("编辑公司失败");
          });
      } else {
        this.searchcompanyname = "";
        PositionApi.createCompany(params)
            .then((res) => {
              this.$message.success("创建公司成功");
              this.handleGetCompany();
              this.isShowCreatedCompany = false;
            })
            .catch((err) => {
              console.log(err);
              this.$message.error("创建公司失败");
            });
      }
    },
    // 获取选中的公司福利
    handleGetwelfare(e) {
      this.selectedCompanywelfare = e;
      // var divtag =
      //   "<div style='line-height:0;margin-left:15px;color:#c0c4cc;'>请选择</div>";
      // if (!!e.length) {
      //   document.getElementsByClassName("el-select__tags")[0].innerHTML =
      //     divtag;
      // } else {
      //   document.getElementsByClassName("el-select__tags")[0].innerHTML = "";
      // }
    },
    // 打开编辑公司弹窗
    handleEditCompany(data) {
      this.editCompanyId = data.id;
      this.isShowCreatedCompany = true;
      this.dialogtitle = "编辑公司";
      PositionApi.getEditCompanyMsg(this.editCompanyId)
        .then((res) => {
          this.companyDialogName = res.data.data.company_name;
          this.company_short = res.data.data.company_short;
          this.foreignDialogName = res.data.data.show_name;
          this.companyDialogInfo = res.data.data.intro;
          this.companyFinancing = res.data.data.capitalization;
          this.companyScale = res.data.data.scale;
          console.log(res.data.data.treatments);
          let arr = [];
          res.data.data.treatments.forEach((item) => {
            arr.push(item.id);
          });
          this.selectedCompanywelfare = arr;
          this.companyLogo = res.data.data.logo.replace(
            /^(?:[^/]*\/){3}(.*)$/,
            "$1"
          );
          // var divtag =
          //   "<div style='line-height:0;margin-left:15px;color:#c0c4cc;'>请选择</div>";
          // if (!!arr.length) {
          //   document.getElementsByClassName("el-select__tags")[0].innerHTML =
          //     divtag;
          // } else {
          //   document.getElementsByClassName("el-select__tags")[0].innerHTML =
          //     "";
          // }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // handleClose(tag) {
    //   this.treatmentsArr.splice(this.treatmentsArr.indexOf(tag), 1);
    //   if (!this.treatmentsArr.length) {
    //     document.getElementsByClassName("el-select__tags")[0].innerHTML = "";
    //   }
    // },
    eachitem(el) {
      for (var i = 0; i < this.CompanywelfareList.length; i++) {
        if (this.CompanywelfareList[i].id === el) {
          return this.CompanywelfareList[i].name;
        }
      }
    },
  },
};
</script>
<style scoped>
.is_double{
  font-size: 13px;
  font-family: MicrosoftYaHei;
  color: #FF7247;
}
/* 上传log */
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 113px;
  height: 40px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 113px;
  height: 40px;
  display: block;
}

.positionBox {
  /* width: 100%;
  height: 100%; */
  overflow: hidden;
}
.positionTitle {
  font-size: 18px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
  margin-top: 9px;
}
.createdPosition {
  position: absolute;
  top: 84px;
  width: 1040px;
  height: 78px;
  background-color: #ffffff;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 0 20px;
}
.createdBtn {
  width: 141px;
  height: 47px;
  margin-left: 22px !important;
  background-color: #0077ff;
}
.searchbox {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666;
  margin-right: 30px;
}
.tableBox {
  width: 1080px;
  min-height: 600px;
  margin-top: 88px;
  background-color: #fff;
}
.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-left: 30px;
}
.pagination span {
  font-size: 12px;
  color: rgba(136, 136, 136, 1);
}
.createPosition {
  width: 100%;
}
.createBox {
  width: 100%;
  /* height: 535px; */
}
.textareabox {
  display: flex;
}
.companyMsg .title {
  border-left: 3px solid #0077ff;
  font-size: 16px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
  padding-left: 13px;
  margin-bottom: 25px;
}
.companyText {
  display: flex;
  align-items: center;
}
.companyText div {
  display: flex;
  align-items: center;
  flex-flow: wrap;
}
.companyText div span:first-child {
  font-size: 14px;
  color: #333;
  margin-right: 6px;
}
.companyTexts {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.companyTexts div {
  display: flex;
  align-items: center;
  flex-flow: wrap;
}
.companyTexts div span:first-child {
  font-size: 14px;
  color: #333;
  margin-right: 6px;
}
.positionMsg .title {
  border-left: 3px solid #0077ff;
  font-size: 16px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
  padding-left: 13px;
  margin-bottom: 25px;
  margin-top: 36px;
}
.bottomBtn {
  width: 136px;
  height: 43px;
  color: #888;
}
.searchbtn {
  text-align: center;
  line-height: 35px;
  display: inline-block;
  width: 90px;
  height: 35px;
  background-color: #0077ff;
  font-family: MicrosoftYaHei;
  color: #fff;
  border-radius: 4px;
  margin: 0 8px;
  cursor: pointer;
}
.resetbtn {
  text-align: center;
  line-height: 35px;
  display: inline-block;
  width: 60px;
  height: 35px;
  border-radius: 4px;
  border: 1px solid rgba(221, 221, 221, 1);
  color: #888;
  cursor: pointer;
}
.uploadimg{
  width: 190px;
  display: flex;
  justify-content: space-between;
  height: 32px;
  display: flex;
  align-items: center;
  position: relative;
}
.avatar-uploader{
  position: absolute;
  left: 45px;
}
</style>
<style>
.createPosition .el-dialog__body {
  width: 100%;
  /* height: 535px; */
  padding-bottom: 0;
}
.createCompany .el-dialog__body {
  padding-bottom: 0;
}
/* .tableBox .el-tabs--top {
  margin-left: 30px;
} */
.tableContent {
  width: 1020px;
  background-color: #fff;
  margin: 0 auto;
}
.tableBox .el-tabs__nav-wrap{
  padding: 0 30px;
}
.tableBox .el-tabs__content {
  padding: 0 30px;
  overflow-y: auto;
  overflow-x: hidden;
}
.companyText div .el-input__inner {
  width: 180px;
  height: 32px;
  border-radius: 0;
}
.companyText div .el-input {
  width: 180px !important;
}
.companyTexts div .el-input__inner {
  width: 100%;
  height: 32px;
  border-radius: 0;
}
.companyTexts div .el-input {
  width: 210px !important;
}
.textareabox .el-textarea {
  width: 884.5px;
}
.textareabox .el-textarea__inner {
  border-radius: 0;
}
.createPosition .el-dialog__footer {
  padding-bottom: 15px;
}
.el-dialog--center {
  min-width: 1020px;
}
.pagination .btn-prev,
.pagination .btn-next {
  width: 76px;
  height: 36px;
  background-color: #fff !important;
  border: 1px solid #eaeaea;
  color: #d1d1d1;
}
.pagination .btn-prev span,
.pagination .btn-next span {
  line-height: 30px;
  text-align: center;
}
.pagination .el-pager li {
  width: 36px;
  height: 36px;
  line-height: 36px;
}
/* 开启禁用弹窗样式 */
.el-message-box__title {
  margin-left: 31px;
}
.el-message-box__status.el-icon-warning {
  margin-top: -41px;
}
.tableBox .el-tabs__active-bar {
  height: 4px;
  border-radius: 2px;
}
.el-message-box__message p {
  font-size: 16px;
  color: #666;
}

.searchbox .el-button--primary {
  width: 90px;
}
.searchbox .el-button--primary span {
  font-size: 14px;
  color: #fff;
}
.searchbox .el-input__inner {
  height: 34px;
  line-height: 34px;
}
.el-tabs__header{
  margin: 0;
}
.el-tabs__item {
  height: auto;
  color: #888;
  font-size: 16px;
  padding: 20px 15px;
  line-height: normal;
}
.el-tabs__item.is-active {
  color: #333;
}
.el-tabs__item:hover {
  color: #333;
}

.pagination .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  border: 1px solid rgba(0, 119, 255, 1);
  color: rgba(0, 119, 255, 1);
}
.pagination .el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  border: 1px solid rgba(234, 234, 234, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  color: rgba(85, 85, 85, 1);
}
.tableBox .el-table thead {
  color: #333;
}
.tableBox .el-table__row .el-table_1_column_1 {
  color: #333 !important;
  font-weight: bold;
  font-size: 12px;
}
.tableBox .el-table__row .el-table_1_column_2 {
  color: #666 !important;
  font-size: 12px;
}
.tableBox .el-table__row .el-table_1_column_3 {
  color: #666 !important;
  font-size: 12px;
}
.tableBox .el-table__row .el-table_1_column_4 {
  color: #666 !important;
  font-size: 12px;
}
.companyTexts .el-tag {
  margin-left: 15px;
}
/* .companytag .el-select__tags > span {
  display: none !important;
} */
.companyTexts .el-select .el-input__icon {
  line-height: 32px !important;
}
.el-cascader-panel > div:first-child .el-checkbox {
  display: none;
}
/* 双选会 */
.new-dialog {
  width: 1280px !important;
  height: 170px !important;
  padding-left: 180px !important;
  background: none !important;
  box-shadow: none !important;
  position: absolute !important;
  left: 0 !important;
  right: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
  margin: auto !important;
}
.new-dialog .el-dialog__header {
  display: none;
}
.positionBox .el-dialog__title{
  font-size: 16px;
  font-family: MicrosoftYaHeiSemibold;
  color: #333333;
  line-height: 21px;
  font-weight: bold;
}
.new-dialog .el-dialog__body {
  padding: 0;
  height: 100%;
  display: flex;
  justify-content: center;
}
.new-dialog .el-dialog__body div {
  width: 180px;
  height: 110px;
  padding: 30px 0;
  position: relative;
  background-color: #fff;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  margin-left: 30px;
}
.new-dialog .el-dialog__body div:first-child{
  margin-left: 0!important;
}
.new-dialog .el-dialog__body div span {
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: #132234;
  line-height: 21px;
}
.new-dialog .el-dialog__body div .new-icon {
  position: absolute;
  left: 0;
  top: 0;
}
.createBox .el-cascader,.el-input__icon{
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/views/position/positionlist.vue